import Logo from "./Logo";
import { useT } from "../i18n/useT";

export default function Footer() {
  const t = useT();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-ink-800/60 py-10">
      <div className="container-page flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between text-sm text-ink-400">
        <div>
          <Logo showSubtitle={false} />
          <p className="mt-3 max-w-md text-xs leading-relaxed">{t.footer.tagline}</p>
        </div>
        <p className="text-xs">© {year} SV4 Ventures · {t.footer.rights}</p>
      </div>
    </footer>
  );
}
